class ImageVideoDocument {

    constructor() {

        this._reader = null;
        this._file = null;
        this._fileType = null;

    }

    _enableHandlers() {
        $("input.type-image-video-input-button:last").one("change.changeImageVideo", this._onImageVideoChange.bind(this));
    }

    _disableHandlers() {
        $("input.type-image-video-input-button:last").off("change.changeImageVideo");
    }

    _onImageVideoChange(event) {

        function _onLoadImage(readerEvent) {

            startImageEdition(readerEvent.target.result);

            const $closeModalImage = $("canvas.closeModalImage");
            const $confirmModalImage = $("canvas.confirmModalImage");

            $closeModalImage.one("click.cancelImageEdition", _onCancelImageEdition);
            $confirmModalImage.on("click.confirmImageEdition", _onConfirmImageEdition);

        }

        function _onCancelImageEdition() {

            const $modalContainer = $("#modalContainer");

            $this.prop("value", "");
            $modalContainer.modal("hide").empty();
            documentationNew.onToggleNewButton();

        }

        function _onConfirmImageEdition() {

            const $modalContainer = $("#modalContainer");
            const editedUploadImage = serializeEditedImg();
            const editedUploadSplit = editedUploadImage.match(/,(.*)$/);
            const uploadFileDef = b64toBlob(editedUploadSplit[1], editedUploadImage.split(";")[0].split(":")[1]);
            const uploadFileIcon = editedUploadSplit[1];

            $this.prop("value", "");
            $modalContainer.modal("hide").empty();

            documentationPublish.drawEnterTransitionScreen();
            api.uploadDocumentPreview(uploadFileDef, _onUploadSuccess, false);

        }

        function _onUploadSuccess(response) {

            if (api.checkisValidResult(response)) {

                const fileUrl = response.result.url;
                const documentType = that._fileType === "image" ? documentationNew.IMAGE : documentationNew.VIDEO;

                documentationPublish.initialize(documentType, fileUrl);

            }

        }

        const $this = $(event.currentTarget);
        const that = this;
        const documentationNew = documentationScreenController.documentationNew;
        const documentationPublish = documentationScreenController.documentationPublish;

        this._file = $this[0].files[0];
        this._fileType = this._file.type.split("/")[0];

        if (this._fileType === "image") {
            this._reader = new FileReader();
            this._reader.onload = _onLoadImage;
            this._reader.readAsDataURL(this._file);
        }

        if (this._fileType === "video") {

            $this.prop("value", "");

            documentationPublish.drawEnterTransitionScreen();
            api.uploadDocumentPreview(this._file, _onUploadSuccess, false);

        }

    }

    initialize() {

        const $typeImageVideoInputButton = $("input.type-image-video-input-button:last");

        this.clearData();
        this._enableHandlers();

        $typeImageVideoInputButton.trigger("click.openFileChooser");

    }

    clearData() {
        try{
            this._reader = null;
            this._file = null;
            this._fileType = null;

            this._disableHandlers();
        } catch(e) {
            console.log(e);
        }
    }

}
